import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
// import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col } from 'reactstrap';
// Local Deps
import './ViewUsers.scss';
// import { addUserRoute } from '../../config/navigation/routes';
import msgs from '../../config/messages';
import ViewUsersHOC from './ViewUsersHOC';
import ViewUsersGrid from '../grids/ViewUsersGrid';
// import NFButton from '../../components/primitives/NFButton';
import Loading from '../Loading';

function ViewUsers({
  users,
  isLoading,
  refreshUsers,
  loading,
  organizationsStatus,
  orgName,
  orgCage,
  auth,
}) {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - View Users Page</title>
      </Helmet>
      <div className="view-users-main-container">
        <div className="view-users-header">
          <h1>User Management</h1>
          <p>View and manage users for your organization.</p>
        </div>
        <div className="nf-view-users">
          <Row>
            <Col style={{ padding: 0 }}>
              {/* <!-- LOADING --> */}
              {isLoading && <Loading text={msgs.ViewUsers.loading} />}

              {/* <!-- CONTENT --> */}
              {!isLoading && (
                <div className="nf-view-users__content">
                  <Row className="nf-row--justify-end" />
                  {/* <!-- USERS GRID --> */}
                  <div className="nf-view-users__grid">
                    <ViewUsersGrid
                      organizationsStatus={organizationsStatus}
                      users={users}
                      loading={loading}
                      refreshUsers={refreshUsers}
                      organizationsName={orgName}
                      organizationsCage={orgCage}
                      auth={auth}
                    />
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

ViewUsers.propTypes = {
  users: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  refreshUsers: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  organizationsStatus: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  orgCage: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    jwtToken: PropTypes.string.isRequired,
    expiration: PropTypes.number.isRequired,
    organizationId: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  }).isRequired,
};

ViewUsers.defaultProps = {
  users: [],
};

export default ViewUsersHOC(ViewUsers);



// WEBPACK FOOTER //
// ./src/components/ViewUsers/ViewUsers.jsx